// extracted by css-extract-rspack-plugin
export default {"cls1":"Upsell-cls1_7jf","cls2":"Upsell-cls2_hES Upsell-cls1_7jf"};